/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponse } from '../../models/profile-response';

export interface SearchProfile$Params {
  search?: string;

/**
 * Enum, see Company Type for possible values. Multiple company types should be split by comma.
 */
  companyType?: string;
}

export function searchProfile(http: HttpClient, rootUrl: string, params?: SearchProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
  const rb = new RequestBuilder(rootUrl, searchProfile.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('companyType', params.companyType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileResponse>>;
    })
  );
}

searchProfile.PATH = '/rest/search-profile';
